import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";

const API = "https://api.m3campus.com";

async function getCsrf() {
  const r = await fetch(`${API}/csrf/`, { credentials: "include" });
  const j = await r.json();
  return j.csrfToken;
}

export default function InscripcionDetalle() {
  const { campusId } = useParams();
  const navigate = useNavigate();

  const [campus, setCampus] = useState(null);
  const [hijos, setHijos] = useState([]);
  const [hijoId, setHijoId] = useState("");

  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);
  const [error, setError] = useState("");

  const [nuevoNombre, setNuevoNombre] = useState("");
  const [nuevoApellidos, setNuevoApellidos] = useState("");
  const [nuevaFecha, setNuevaFecha] = useState("");
  const [telefono, setTelefono] = useState("");
  const [autorizaImagen, setAutorizaImagen] = useState(true);

  const [detallesAbiertos, setDetallesAbiertos] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setError("");
      try {
        const res = await fetch(`${API}/api/campus/${campusId}/`, {
          credentials: "include",
        });
        if (!res.ok) throw new Error("No se pudo cargar el campus");
        const data = await res.json();
        setCampus(data);

        const rh = await fetch(`${API}/api/hijos/`, {
          credentials: "include",
        });
        const hj = await rh.json();
        setHijos(hj.hijos || []);
        if ((hj.hijos || []).length > 0) {
          setHijoId(String(hj.hijos[0].id));
          setDetallesAbiertos(false);
        } else {
          setDetallesAbiertos(true);
        }
      } catch (e) {
        console.error(e);
        setCampus(null);
        setError(e.message || "Error cargando datos");
      } finally {
        setLoading(false);
      }
    })();
  }, [campusId]);

  const crearHijo = async () => {
    try {
      setError("");

      if (!nuevoNombre.trim()) {
        setError("Pon al menos el nombre del niño.");
        return;
      }

      if (!telefono.trim()) {
        setError("Introduce un teléfono.");
        return;
      }

      const csrf = await getCsrf();

      const r = await fetch(`${API}/api/hijos/create/`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrf,
        },
        body: JSON.stringify({
          nombre: nuevoNombre.trim(),
          apellidos: nuevoApellidos.trim(),
          fecha_nacimiento: nuevaFecha || null,
          autorizacion_imagen: autorizaImagen,
          telefono: telefono.trim(),
        }),
      });

      const j = await r.json();
      if (!r.ok) throw new Error(j.detail || "No se pudo crear el hijo");

      const nuevo = j.hijo;
      const nuevaLista = [...hijos, nuevo];
      setHijos(nuevaLista);
      setHijoId(String(nuevo.id));

      // limpiar formulario
      setNuevoNombre("");
      setNuevoApellidos("");
      setNuevaFecha("");
      setTelefono("");
      setAutorizaImagen(true);
      setDetallesAbiertos(false);
    } catch (e) {
      setError(e.message || "No se pudo crear el hijo");
    }
  };

  const addToCart = async () => {
    setError("");

    if (Number(campus?.plazas_disponibles ?? 0) <= 0) {
      setError("No quedan plazas disponibles para este campus.");
      return;
    }

    if (!hijoId) {
      setError("Selecciona (o crea) un hijo antes de añadir al carrito.");
      return;
    }

    setAdding(true);
    try {
      const csrf = await getCsrf();
      const r = await fetch(`${API}/api/cart/add/`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrf,
        },
        body: JSON.stringify({
          campus_id: Number(campusId),
          hijo_id: Number(hijoId),
        }),
      });

      const j = await r.json();
      if (!r.ok) throw new Error(j.detail || "No se pudo añadir al carrito");

      navigate("/carrito");
    } catch (e) {
      setError(e.message || "Error");
    } finally {
      setAdding(false);
    }
  };

  if (loading) return <div style={{ padding: 24 }}>Cargando campus…</div>;
  if (!campus) return <div style={{ padding: 24 }}> Regístrese o inicie sesión para para poder inscribirse en este campus</div>;

  const sinPlazas = Number(campus?.plazas_disponibles ?? 0) <= 0;

  return (
    <div style={{ padding: 24, maxWidth: 900 }}>
      <h2>{campus.nombre}</h2>

      {campus.foto && (
        <img
          src={campus.foto}
          alt={campus.nombre}
          style={{ width: "100%", maxWidth: 600, borderRadius: 12 }}
        />
      )}

      <p style={{ marginTop: 12, whiteSpace: 'pre-line' }}>{campus.descripcion}</p>

      <p style={{ marginTop: 12 }}>
                Para mas información del contenido del campus diríjase a la pestaña{" "}
               <Link
                        to="/menu2"
                               style={{
                                color: "#1976d2",
                                textDecoration: "underline",
                                fontWeight: 600,
                                      }}
                     >
                 "Contenido didáctico de los Campus"
               </Link>
       </p>

      <p style={{ marginTop: 12 }}>
        También puede formalizar la matrícula a través de WhatsApp pulsando este enlace:
      </p>
      <a
        href="https://wa.me/34614855708"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          color: "#25D366",
          textDecoration: "none",
          fontWeight: 700,
        }}
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
          style={{ width: 28, height: 28 }}
        />
        +34 614 855 708
      </a>

      <p style={{ fontWeight: 700, marginTop: 16 }}>Precio: {campus.precio} €</p>
      <p style={{ fontWeight: 700 }}>Lugar: {campus.lugar}</p>
      <p style={{ fontWeight: 700 }}>Fecha: {new Date(campus.fecha).toLocaleDateString("es-ES", {
                     day: "numeric",
                    month: "long",
                    year: "numeric",
                                    })}</p>

      {typeof campus.plazas_disponibles === "number" && (
        <p style={{ fontWeight: 700 }}>
          Plazas disponibles: {campus.plazas_disponibles}
        </p>
      )}

      {error && <div style={{ marginTop: 12, color: "crimson" }}>{error}</div>}

      <div
        style={{
          marginTop: 18,
          padding: 14,
          border: "1px solid #eee",
          borderRadius: 12,
        }}
      >
        <h3 style={{ marginTop: 0 }}>
          Necesitamos los datos del niño/adolescente para realizar matricula.¿Para qué niño es esta inscripción?
        </h3>

        {sinPlazas ? (
          <div style={{ color: "crimson", fontWeight: 700 }}>
            Plazas no disponibles
          </div>
        ) : (
          <>
            {hijos.length > 0 ? (
              <>
                <label style={{ display: "block", marginBottom: 12 }}>
                  Selecciona un perfil ya creado:
                  <select
                    value={hijoId}
                    onChange={(e) => setHijoId(e.target.value)}
                    style={{
                      display: "block",
                      marginTop: 6,
                      padding: 8,
                      width: "100%",
                      maxWidth: 420,
                    }}
                  >
                    {hijos.map((h) => (
                      <option key={h.id} value={h.id}>
                        {h.nombre} {h.apellidos || ""}
                      </option>
                    ))}
                  </select>
                </label>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    margin: "16px 0",
                    maxWidth: 420,
                    color: "#888",
                    fontSize: 14,
                  }}
                >
                  <div style={{ flex: 1, height: 1, background: "#ddd" }} />
                  <span>o</span>
                  <div style={{ flex: 1, height: 1, background: "#ddd" }} />
                </div>
              </>
            ) : (
              <div
                style={{
                  marginBottom: 12,
                  padding: 12,
                  background: "#fff8e1",
                  border: "1px solid #ffe082",
                  borderRadius: 8,
                  color: "#6d4c00",
                }}
              >
                <strong>⚠️ Todavía no tienes ningún perfil creado.</strong>
                <br />
                Rellena los datos de abajo para crear el perfil del niño/a y poder inscribirlo.
              </div>
            )}

            <div style={{ marginBottom: 12 }}>
              <div
                onClick={() => setDetallesAbiertos(!detallesAbiertos)}
                style={{
                  cursor: "pointer",
                  fontWeight: 700,
                  userSelect: "none",
                  padding: "4px 0",
                }}
              >
                {detallesAbiertos ? "▼" : "▶"}{" "}
                {hijos.length === 0
                  ? "Crear perfil del niño/a"
                  : "Crear un nuevo perfil"}
              </div>

              {detallesAbiertos && (
                <div
                  style={{
                    marginTop: 10,
                    display: "grid",
                    gap: 10,
                    maxWidth: 420,
                  }}
                >
                  <input
                    placeholder="Nombre"
                    value={nuevoNombre}
                    onChange={(e) => setNuevoNombre(e.target.value)}
                  />

                  <input
                    placeholder="Apellidos"
                    value={nuevoApellidos}
                    onChange={(e) => setNuevoApellidos(e.target.value)}
                  />

                  <input
                    placeholder="Teléfono de Padre, Madre o Tutor"
                    value={telefono}
                    onChange={(e) => setTelefono(e.target.value)}
                  />

                  <label style={{ fontSize: 14, color: "#555" }}>
                    Fecha de Nacimiento
                    <input
                      type="date"
                      value={nuevaFecha}
                      onChange={(e) => setNuevaFecha(e.target.value)}
                      style={{ display: "block", marginTop: 4, width: "100%" }}
                    />
                  </label>

                  <label style={{ display: "flex", gap: 8 }}>
                    <input
                      type="checkbox"
                      checked={autorizaImagen}
                      onChange={(e) => setAutorizaImagen(e.target.checked)}
                    />
                    Autorizo la toma y difusión de imágenes de mi hijo con el único propósito de publicidad del Campus
                  </label>

                     <button
                          onClick={crearHijo}
                             style={{
                                    padding: "10px 16px",
                                    background: "#f5f5f5",
                                    color: "#333",
                                    border: "1px solid #ccc",
                                    borderRadius: 6,
                                    cursor: "pointer",
                                    fontSize: 15,
                                    fontWeight: 600,
                                  }}
                      >
                                 Crear hijo
                    </button>


                </div>
              )}
            </div>

                    <button
                      onClick={addToCart}
                      disabled={adding || !hijoId}
                      style={{
                        width: 420,
                        maxWidth: "100%",
                        padding: "20px 16px",
                        background: "#1976d2",
                        color: "#fff",
                        border: "none",
                        borderRadius: 8,
                        fontSize: 17,
                        fontWeight: 700,
                        opacity: (!hijoId || adding) ? 0.5 : 1,
                        cursor: (!hijoId || adding) ? "not-allowed" : "pointer",
                        boxShadow: (!hijoId || adding) ? "none" : "0 2px 6px rgba(25, 118, 210, 0.3)",
                        transition: "all 0.2s",
                      }}
                      title={!hijoId ? "Primero crea o selecciona un perfil" : ""}
                    >
                      {adding ? "Añadiendo..." : "Añadir al carrito"}
                    </button>

            {!hijoId && (
              <div style={{ marginTop: 8, fontSize: 13, color: "#888" }}>
                Primero crea un perfil arriba para poder añadir al carrito.
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}